import styled from "styled-components";

export const InputArea = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const InputContainer = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;

  input[type="radio"] {
      width: 16px !important;
      height: 16px !important;
      border: #BEBEBE solid 1px;
      margin: 0;
      flex-shrink: 0;
  }

  input[type="radio"]:before {
      width: 16px !important; 
      height: 16px !important;
      border: #BEBEBE solid 1px;
  }

  input[type="radio"]:after {
      width: 16px !important; 
      height: 16px !important;
  }

  input[type="radio"]:checked:after {
      width: 10px !important; 
      height: 10px !important;
      top: 3.1px;
      left: 3.1px;
      background: #0E4C54;
  }

    label {
          padding-left: 0;
          font-size: 12px !important;
          font-weight: 400;
          text-align: left;
          color: #364863;
          font-family: 'Lato', sans-serif;
          margin: 0;
    }

  .selectDisabled {
      display: flex;
      flex-direction: row;
      align-items: center;
      margin-top: 10px;
      color: #7a7a7a;
      label {
          padding-left: 6px;
          font-size: 12px !important;
          font-weight: 500;
          text-align: left;
      }

      input[type="radio"]:before {
          background: #F2F2F2;
      }    
  }
`